import React, { useState } from "react"
import { Container, Grid, Button} from "@material-ui/core";
import { useSelector } from "react-redux"
import CbAgentes from "../CbAgentes"
import TComisiones from "../TComisiones"
import HomePage from "../../Home"
import FPagos from "../FPagos"
 
const VPagarComision = () => {
    const comisionesAgente = useSelector(store => store.cotizacion.comisionesAgente);
    const [openModal, setOpenModal] = useState(false);

    const handleOpen = () =>{
        setOpenModal(true);
    }

    return (

        <HomePage>        
            <Container>
                <Grid item xs={12}>
                    <CbAgentes esPago={true} esReporte={false} />
                </Grid>
                <Grid item xs={12}>
                    <TComisiones 
                        rows={comisionesAgente}
                        isPago = {true}
                        isReporte = {false}
                    />
                </Grid>
                <Grid item xs={12}>
                    <div style={{textAlign: "right", marginTop: "10px"}}> 
                     <Button onClick={handleOpen} variant="contained" color="primary">Pagar</Button>             
                    </div>
                </Grid>
                <FPagos open={openModal} setOpenModal={setOpenModal} />
            </Container>
        </HomePage>
    )
}
export default VPagarComision